import styled from 'styled-components';
import { ButtonGroupWrapper } from '@mlb/react-patterns/v4/components/ButtonGroup/buttonGroup.style';
import { LineScoreWrapper } from '@mlb/react-patterns/v4/components/LineScore/lineScore.style';
import { StyledTable, TableScroller } from '@mlb/react-patterns/v4/components/Table/table.style';
import GDBREAKPOINTS, { ATBAT_MODAL_BREAKPOINT } from '../themes/breakpoints';
import { CardWrapper } from '../Card/Card.style';
import { BoxscoreWrapper, BoxscoreTabsWrapper, BoxscoreTeamsGridWrapper, BoxScrollWrapper } from '../Boxscore/Boxscore.style';
import { TeamTable } from '../Boxscore/boxscore/boxscoreTeam/BoxscoreTeamTable.style';
import { FVButton } from '../FieldVision/fieldvision.style';
import { GameOverWrapper } from '../GameOver/GameOver.style';
import { GamedayLineScoreWrapper } from '../LineScore/LineScore.style';
import { MatchupWrapper as ParentMatchupWrapper } from '../Matchup/Matchup.style';
import { PlayFeedWrapper } from '../PlayFeed/PlayFeed.style';
import { PanelContainer, RightContainer } from '../Panel/Panel.style';
import { MatchupWrapper, PlayerDuelStatsDash, PlayerDuelWrapper } from '../PlayerDuel/PlayerDuel.style';
import { UpcomingBattersContainer } from '../PlayerDuel/components/UpcomingBatters/UpcomingBatters.style';
import { PlayerListWrapper } from '../PlayerList/PlayerList.style';
import { PlayerMatchupWrapper } from '../PlayerMatchup/PlayerMatchup.style';
import { FieldWrapper, StadiumWrapper, PitchFxWrapper, PitchFxContainerWrapper } from '../PitchFx/PitchFx.style';
import { CloseButton } from '../Overlay/overlay.style';
import { FiltersWrapper, SummaryPlayListWrapper, Divider, SummaryWrapper } from '../Summary/summary.style';
import { TeamSkeletonWrapper, TeamSummaryMatchUpWrapper } from '../TeamSummaryMatchup/TeamSummaryMatchup.style';
import { PlayerDataWrapper, PlayerInfoWrapper, PlayerStatsWrapper } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import { MidAdWrapper } from '../Ads/components/ad.style';
import { Content } from '@mlb/react-patterns/v4/components/AccordionItem/AccordionItem.style';
import playTypeMap from '../DynamicFieldView/utils/playTypeMap';
const { PITCH, RESULT } = playTypeMap;

const {
    MD
} = GDBREAKPOINTS;

const { SINGLENARROW, SINGLEWIDE, FULL, SINGLE, TWOCOLS, FULLWIDE, FULLNARROW } = liveViewsTypes;

/* total width + spacing for fixed-width columns in each viewport */
const totalPanelWidths = {
    [TWOCOLS]: '423px',
    [FULL]: '814px',
    [FULLNARROW]: '814px',
    [FULLWIDE]: '1207px'
};

export const ViewScrollWrapper = styled.div`
    height: ${({ $top }) => $top ? `calc(100vh - ${$top}px)` : '100%'};
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    ${Content} {
        border-bottom: 1px solid var(--gameday-divider-color); // this is for the DFV content
    }
`;

export const FieldVisionButtonWrapper = styled.div`
    position: absolute;
    top:16px;
    right: 16px;
    width: auto;
    height: auto;
    z-index: 10;

    ${({ $type }) => {
        if ($type === SINGLE || $type === SINGLEWIDE || $type === SINGLENARROW) {
            return `
                top:56px;
            `;
        }
    }};

    button {
        position: relative;
        top: auto;
        right: auto;
    }
`;

export const LiveSummaryBoxWrapper = styled.div`
    --gameday-live-view-padding: 16px;

    ${({ $type }) => {
        if ($type !== SINGLE && $type !== SINGLEWIDE && $type !== SINGLENARROW) {
            return `
                flex: 1 1 auto;
                overflow: hidden;
                margin-right: -16px;
                margin-left: -16px;
                padding-bottom: 53px;
                padding-left: 16px;
                padding-right: 16px;
            `;
        }
    }};

    ${BoxScrollWrapper} {
        ${({ $type }) => {
        if ($type !== SINGLE && $type !== SINGLEWIDE && $type !== SINGLENARROW) {
            return `
                    margin-left: -16px;
                    padding-left: 16px;
                `;
        }
    }}
    }
    ${ViewScrollWrapper} {
        padding-right: 0px;
        ${({ $type }) => {
        if ($type !== SINGLE && $type !== SINGLEWIDE && $type !== SINGLENARROW) {
            return `
                margin-left: -16px;
                padding-left: 16px;
            `;
        }
    }};
        ${CardWrapper} {
            ${({ $type }) => {
        if ($type === SINGLE || $type === SINGLEWIDE) {
            return `
                        margin: 16px;
                    `;
        }
    }};

            &.matchup-card {
                transition: margin 0.3s;
            }

            &.stuck {
                box-sizing: border-box;
                border-bottom: 1px solid var(--gameday-divider-color);
                border-radius: 0;
                margin: 0;
            }
        }
    }

    ${TeamSummaryMatchUpWrapper} {
        // Align with the top of the card
        margin: 0 -10px 0px -10px;
        padding: 10px 10px 0 10px;
    }

    ${PlayFeedWrapper} {
        margin: 8px 16px 33px 16px;
        ${({ $type }) => {
        let temp = '';
        if ($type === SINGLE || $type === SINGLEWIDE || $type === SINGLENARROW) {
            temp = temp + 'margin-bottom:15px;';
        }
        if ($type === SINGLE || $type === SINGLEWIDE) {
            temp = temp + `
                margin-top: 0px;
                margin-left: 0px;
            `;
        }
        return temp;
    }};
    }


    ${SummaryPlayListWrapper} {
        padding-left: var(--gameday-live-view-padding);
        padding-right: var(--gameday-live-view-padding);
        ${({ $type }) => {
        if ($type !== SINGLE && $type !== SINGLEWIDE && $type !== SINGLENARROW) {
            return `
                margin: var(--gameday-section-padding-sm);
                margin-top: 0px;
            `;
        }
    }};
    }

    ${Divider} {
        margin:0;
    }
`;

export const PanelScreenWrapper = styled.div`
    button {
        top:0;
        right:0;
        color: var(--gameday-tab-button-inactive-color);

        &[data-selected=true] {
            color: var(--gameday-tab-button-active-color);
        }
        padding: 0;
        margin: 0 24px 0 0;

        &:last-child {
            margin-right: 0;
        }
    }
`;

export const ChipPositionWrapper = styled.div`
    left: calc(50% - 171px);
    bottom: 0;
    ${({ $type }) => {
        let temp = '';
        if ($type === TWOCOLS) {
            temp = temp + `
                margin-left: calc(385px/2) !important;
                bottom: 139.5px;
            `;
        }

        if ($type === SINGLE || $type === SINGLEWIDE || $type === SINGLENARROW) {
            temp = temp + `
                position: absolute;
                bottom: auto;
                top: auto;
                transform: translateY(-100%);
                width: calc(100% - 32px);
                box-shadow: none;
            `;
        }
        if ($type === FULLNARROW) {
            temp = temp + `
                bottom: 180px;
            `;
        }
        return temp;
    }};
`;

export const ChipFeedWrapper = styled(ChipPositionWrapper)`
    width: 343px;
    height: auto;
    position: absolute;
    z-index: 2;
    margin: 0 auto;
`;

export const ChipFeedStaticWrapper = styled(ChipFeedWrapper)`
    position: static;
    ${({ $playType }) => ($playType === PITCH || $playType === RESULT) && 'height: 100px; display: grid;'};
`;

export const LiveWrapper = styled.div`
    position: relative;
    height: 100%;
    flex: 1 1 100%;
    overflow: hidden;
    ${({ type }) => type === SINGLENARROW ? 'background-color: var(--gameday-background-color);' : 'background-color: var(--gameday-live-background-color);'}

    ${SummaryWrapper} {
        padding-bottom: var(--gameday-section-padding-sm);
        ${({ type }) => {
        if (type === SINGLE || type === SINGLEWIDE) {
            return `
                ${CardWrapper} {
                    padding: 0px;
                    margin-top: 8px !important;
                }
            `;
        }
    }};
    }

    ${BoxscoreTabsWrapper} {
        ${({ type }) => (type !== TWOCOLS) ? 'padding-left: var(--gameday-section-padding-sm);' : ''};
        padding-right: var(--gameday-section-padding-sm);
        ${({ type }) => (type !== FULL) ? 'margin-right: 0px;' : ''};
        ${({ type }) => {
        if (type === FULL || type === FULLNARROW) {
            return `
                    position: sticky;
                    top: 0px;
                    background: var(--gameday-background-color);
                    z-index: 9;
                    padding-top: 1px;
                `;
        }
    }};
        >div {
            padding-bottom: 0;
            margin: 8px 0px;
            ${({ type }) => {
        if (type === SINGLE) {
            return `
                        margin-top: 0px;
                        padding-top: 8px;
                    `;
        }
    }};
        }
    }

    ${GamedayLineScoreWrapper} {
        margin: 0px;
        line-height: initial;
        height: 84px;
        border-bottom: 1px solid var(--gameday-divider-color);
        padding-left: var(--gameday-section-padding-sm);
        padding-right: var(--gameday-section-padding-sm);
        margin-top: var(--gameday-section-padding-sm);
        background-color: var(--gameday-live-element-background);
        ${({ type }) => type === TWOCOLS ? 'margin-top: 16px;' : ''}
        ${({ type }) => {
        if (type === FULLWIDE) {
            return `
                ${LineScoreWrapper} {
                    display: flex;
                    justify-content: space-between;
                    max-width: 100%;
                    >div:first-child {
                        overflow: visible;
                        flex-basis: 65%;
                        ${TableScroller} {
                            margin-left: 150px;
                        }
                    }
                    >div:last-child {
                        flex-basis: 19%;
                        margin-right: -11px;
                        }
                    }
                    table {
                        tbody {
                            td {
                                &[data-highlighted='true'] {
                                    div {
                                        left: 50%;
                                        transform: translateX(-50%);
                                    }
                                }
                            }
                        }
                    }
                }
            `;
        }
        if (type === SINGLE || type === SINGLEWIDE) {
            return `
                padding-top: 16px;
                margin-top: 0px;
                height: 100px;
                border-bottom: 0;
                flex-basis: 62%;
                padding-right: 0;
                ${LineScoreWrapper} {
                    display: flex;
                    justify-content: space-between;
                    max-width: 100%;
                    >div:first-child {
                        overflow: visible;
                        flex-basis: 75%;
                    }
                    >div:last-child {
                        flex-basis: 23%;
                    }
                    ${StyledTable} {
                        tbody {
                            td {
                                &[data-highlighted='true'] {
                                    div {
                                        left: 50%;
                                        transform: translateX(-50%);
                                        top: 6px;
                                    }
                                }
                            }
                        }
                    }
                }
            `;
        }
    }}
    }

    ${PitchFxWrapper} {
        margin: -75% -65% -50% -90.59%;
        width: 280%;
    }

    ${UpcomingBattersContainer} {
        margin-left: var(--gameday-section-padding-sm);
        margin-right: var(--gameday-section-padding-sm);
    }

    ${PlayerDuelWrapper} {
        ${({ type }) => (type === SINGLENARROW) ? 'margin-top: 16px;' : ''}
        ${PlayerDuelStatsDash} {
            display: ${({ type }) => (type === SINGLENARROW || type === FULLNARROW) ? 'none' : 'block'};
        }
    }

    ${PlayerDataWrapper} {
        ${({ type }) => (type === FULLNARROW) ? 'height: auto;' : ''}
    }

    ${PlayerStatsWrapper} {
        ${({ type }) => {
        if (type === SINGLENARROW || type === FULLNARROW) {
            return `
                    justify-content: center;

                    .after-list {
                        margin-top: 0px;
                    }

                    .before-list {
                        margin-top: 0;
                    }
                `;
        }
    }};
    }

    ${ParentMatchupWrapper} {
        width: auto;
        ${MatchupWrapper} {
            padding: 0px;
        }
    }

    ${RightContainer} {
                ${({ type }) => {
        if (type === FULLWIDE) {
            return `
                width: 768px;
            `;
        }
    }}
            }
    ${PanelContainer} {
        top:0;
        z-index:2;
        >div {
            padding: 0px;
        }
        ${LiveSummaryBoxWrapper} {
            --gameday-live-view-padding: 0px;
        }
        ${FiltersWrapper} {
            margin-left: -16px;
            margin-right: -16px;
            width: calc(100% + 32px);
            >div {
                margin: 0 var(--gameday-section-padding-sm);
            }
        }

        ${TeamSummaryMatchUpWrapper} {
            // Align with the top of the card
            border-top-left-radius: inherit;
            border-top-right-radius: inherit;
            background-color: var(--gameday-background-color);
            padding: var(--gameday-section-padding-sm);
        }
    }

    ${TeamSummaryMatchUpWrapper} {
        background: var(--gameday-background-color);
        height: 64px;
        ${({ type }) => {
        if (type === SINGLE || type === SINGLEWIDE || type === SINGLENARROW) {
            return `
                border-bottom: 1px solid var(--gameday-divider-color);
            `;
        }
    }};
    }

    ${TeamSkeletonWrapper} {
        background: var(--gameday-background-color);
    }

    ${PlayerListWrapper} {
        ${({ type }) => {
        if (type === SINGLENARROW) {
            return `
                margin-left: var(--gameday-section-padding-sm);
                margin-right: var(--gameday-section-padding-sm);
            `;
        }
    }};
    }

    ${PlayerInfoWrapper} {
        align-items: baseline;
        margin-bottom: 6px;
    }
`;

export const LiveWrapperStretch = styled(LiveWrapper)`

    --gameday-pfx-full: 100%;
    --gameday-pfx-scale: 8%;
    --gameday-aspect-ratio-height: var(--gameday-pfx-full);
    --gameday-aspect-ratio-width: auto;
    --gameday-aspect-ratio-width-layout: center;
    --gameday-aspect-ratio-height-layout: stretch;

    &.live-orientation-landscape {
        --gameday-aspect-ratio-height: auto;
        --gameday-aspect-ratio-width: var(--gameday-pfx-full);
        --gameday-aspect-ratio-width-layout: stretch;
        --gameday-aspect-ratio-height-layout: center;
    }

    ${PitchFxContainerWrapper} {
        position:absolute;
        top: calc( -1 * var(--gameday-pfx-scale));
        right: calc( -1 * var(--gameday-pfx-scale));
        bottom: 0;
        left: calc( -1 * var(--gameday-pfx-scale));
        margin-bottom: -2%;
    }

    ${PitchFxWrapper} {
        height: 100%;
        width: 100%;
        ${({ type }) => {
        if (type === FULLNARROW) {
            return `
                margin: -2% 0 0 0;
                height: 106%;
            `;
        }
    }}
    }

    ${StadiumWrapper} {
        display:flex;
        justify-content:center;
        align-items:flex-end;
    }

    ${FieldWrapper} {
        width: var(--gameday-aspect-ratio-width);
        height: var(--gameday-aspect-ratio-height);
        justify-content: var(--gameday-aspect-ratio-height-layout);
        align-items: var(--gameday-aspect-ratio-width-layout);
        overflow:visible;
        max-height: var(--gameday-pfx-max-height);
        .responsive-pitch-fx-aspect-ratio {
            width: var(--gameday-aspect-ratio-width);
            height: var(--gameday-aspect-ratio-height);
            justify-content: var(--gameday-aspect-ratio-height-layout);
            align-items: var(--gameday-aspect-ratio-width-layout);
        }
    }
`;

export const LiveWrapperFull = styled(LiveWrapperStretch)`
    ${FVButton} {
        transition-duration: .3s;
        right: ${({ shiftFVButton }) => shiftFVButton ? '446px' : '56px'};
        ${({ type }) => {
        if (type === FULL || type === FULLWIDE) {
            return `
                right: 16px;
            `;
        }
        if (type === FULLNARROW) {
            return `
                top: 96px;
                right: 407px;
            `;
        }
    }}
    }
`;

export const LiveWrapperTwoCols = styled(LiveWrapperStretch)`
    ${PitchFxWrapper} {
        margin: -260.7px 0 0 0;
        width: calc(100% + 385px);
        height: calc(100% + 411.7px);
    }
    ${FVButton} {
        top: 96px;
        z-index: 2;
    }
`;

/* Only used on single column */
export const LayoutWrapper = styled.div`
    position: relative;
    ${TeamSummaryMatchUpWrapper},
    ${FVButton} {
        top: 16px;
        z-index: 2;
    }
    ${PitchFxWrapper} {
        ${({ type }) => {
        if (type !== SINGLENARROW) {
            return `
                width: 140%;
                height: auto;
                margin: -22% 0 -19% -20.4%;
            `;
        }
    }};
    }
`;

export const PanelWrapper = styled.div`
    width: 375px;
    height: auto;
    position: absolute;
    top: 0;
    background: var(--gameday-background-color);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;

    z-index: 3;
    &:first-child {
        left:0;
    }
    margin: 16px;

    ${({ type }) => {
        if (type === 'full') {
            return `
                &:last-child {
                    right:0;
                }
            `;
        }
    }}
`;

export const CardContentWrapper = styled(CardWrapper)`
    z-index: 2;
    position: absolute;
    left: 389px;
    margin: 16px;
    box-sizing: border-box;
    padding: 0;
    overflow: hidden;
    ${({ type }) => {
        let temp = '';
        if (totalPanelWidths?.[type]) {
            temp = temp + `
                width: calc(100% - ${totalPanelWidths[type]});
            `;
        }
        if (type === TWOCOLS) {
            temp = temp + `
                right: 0;
            `;
        }
        if (type === FULLNARROW) {
            temp = temp + `
                left: calc(50% - 16px);
                transform: translateX(-50%);
            `;
        }
        if (type !== FULL && type !== FULLWIDE) {
            temp = temp + `
                box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.24);
            `;
        }
        return temp;
    }};
`;

export const ScoresCardWrapper = styled(CardContentWrapper)`
    top: 0px;
    max-height: 64px;
`;

export const MatchUpCardWrapper = styled(CardContentWrapper)`
    bottom: 0px;
    ${({ type }) => type === FULLNARROW ? 'max-height: 226px' : 'max-height: 125px'};
`;

export const PitchFxCardWrapper = styled(CardContentWrapper)`
    display: flex;
    flex: 1 1 100%;

    --gameday-pfx-full: 100%;
    --gameday-pfx-scale: 8%;
    --gameday-pfx-margin-bottom: -20%;
    --gameday-aspect-ratio-height: var(--gameday-pfx-full);
    --gameday-aspect-ratio-width: auto;
    --gameday-aspect-ratio-width-layout: center;
    --gameday-aspect-ratio-height-layout: stretch;
    --gameday-pfx-max-height: 100%;

    justify-content: var(--gameday-aspect-ratio-height-layout);
    align-items: var(--gameday-aspect-ratio-width-layout);

    &.live-orientation-landscape {
        --gameday-pfx-full: 100%;
        --gameday-pfx-scale: 20%;
        --gameday-pfx-margin-bottom: -20%;
        --gameday-aspect-ratio-height: auto;
        --gameday-aspect-ratio-width: var(--gameday-pfx-full);
        --gameday-aspect-ratio-width-layout: stretch;
        --gameday-aspect-ratio-height-layout: center;
        --gameday-pfx-max-height: auto;

        ${MidAdWrapper} {
            ${({ type }) => (type === FULLWIDE || type === FULL) && 'width: 71.5%;'}};
        }

    top: 80px;
    height: calc(100% - 253px);
    margin-bottom: 0;

    ${PitchFxContainerWrapper} {
        margin-bottom: var(--gameday-pfx-margin-bottom);
    }
    ${PitchFxWrapper} {
        margin: 0 0 0 0;
        width: 100%;
        height: 100%;
        position: relative;
    }
`;

export const InfoDivider = styled.div`
    height: 1px;
    background-color: var(--gameday-divider-color);
`;

export const MatchupInfoDivider = styled(InfoDivider)`
    margin-top: 16px;
`;

export const MainTabsWrapper = styled.div`
    padding-left: 16px;
    background-color: var(--gameday-background-color);
    ${ButtonGroupWrapper} {
        padding-bottom: 0px;

        button {
            margin-right: 24px;
            padding-left:0;
            padding-right:0;
            color: var(--gameday-tab-button-inactive-color);
            &[data-selected=true] {
                color: var(--gameday-tab-button-active-color);
            }
            ${({ type }) => (type === SINGLE || type === SINGLEWIDE) && 'margin-right: 64px;'};
        }
    }
`;

export const StretchOverPaddingWrapper = styled.div`
    margin: 0 -16px;
    padding: 0 16px;
`;

export const GameOverModelWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    background: var(--gameday-overlay-background-color);
    border-radius: var(--gameday-border-radius);
    max-height: 900px;
    isolation: isolate;
    margin: var(--gameday-section-padding-sm) 0;
    overflow: hidden;
    overflow-y: auto;
    /* keep media query since overlay live view layout has no impact on this  */
    @media (max-width: ${ATBAT_MODAL_BREAKPOINT}) {
        width: 359px;
    }

    >div {
        padding: 0px;
        position: relative;
        >button {
            position: absolute;
            top: 24px;
            right: 24px;
        }
    }
    ${GameOverWrapper} {
        padding: var(--gameday-section-padding-sm);
    }
    ${CloseButton} {
        top: var(--gameday-section-padding-sm);
    }
    @media (min-width: ${MD}) {
        ${GameOverWrapper} {
            padding: var(--gameday-section-padding);
        }
        ${CloseButton} {
            top: var(--gameday-section-padding);
        }
    }
`;

export const NoOktaModelWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    background: var(--gameday-overlay-background-color);
    border-radius: var(--gameday-border-radius);
    margin: var(--gameday-section-padding-sm) 0;
    overflow: hidden;
    overflow-y: auto;
    max-width: 327px !important;
`;

export const BoxTabHeaderWrapper = styled.div`
    ${({ $type }) => {
        if ($type === SINGLE || $type === SINGLEWIDE) {
            return `
                display: flex;
                background-color: var(--gameday-background-color);
                width: 100%;
                border-bottom: 1px solid var(--gameday-divider-color);
                justify-content: center;
                gap: calc(var(--gameday-section-padding-sm) - 4px);
                ${PlayerMatchupWrapper} {
                    padding-left: calc(var(--gameday-section-padding-sm) - 4px);
                    padding-right: var(--gameday-section-padding-sm);
                    flex: 1;
                }
            `;
        }
    }
}`;

export const BoxTabHeaderDivider = styled.div`
    width: 1px;
    background-color: var(--gameday-divider-color);
    height: 72px;
    display: flex;
    margin-top: var(--gameday-section-padding-sm);
    margin-left: 0;
    margin-right: 0;
`;

export const NoOktaWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    font-weight: 700;
    font-size: 16px;
    line-height: 21px;
    width: calc(100% - 32px);
    max-width: 327px;
    margin-left: 16px;
    margin-top:10px;
    text-align: center;
`;

export const LimitedFunctionalityChip = styled(ChipPositionWrapper)`
    position: absolute;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--gameday-limited-functionality-chip-background);
    color: var(--gameday-limited-functionality-chip-color);
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 16px;
    width: max-content;

    ${({ $type }) => {
        if ($type === SINGLE || $type === SINGLEWIDE || $type === SINGLENARROW) {
            return `
                transform: translateY(-100%) translateX(-50%);
                margin-top: -16px;
            `;
        }
    }};

`;

export const LiveBoxscoreWrapper = styled.div`
    height: 100%;
    overflow-y: ${({ $type }) => ($type === SINGLE || $type === SINGLEWIDE) ? 'visible' : 'auto'};
    ${BoxscoreWrapper} {
        box-sizing: border-box;
        ${BoxScrollWrapper} {
            padding: 16px 16px 0px;
            margin-right: 0px;
        }
        ${({ $type }) => {
        let temp = '';
        if ($type === SINGLE || $type === SINGLEWIDE || $type === SINGLENARROW) {
            temp = temp + 'background-color: var(--gameday-background-color);';
        }

        if ($type === TWOCOLS) {
            temp = temp + `
                            padding-left: 16px;
                        `;
        }
        if ($type === FULLWIDE || $type === FULL || $type === FULLNARROW) {
            temp = temp + `
                            margin-bottom: 0px;
                        `;
        }
        if ($type === SINGLEWIDE || $type === FULLWIDE) {
            temp = temp + `
                    padding-bottom: 16px;
                `;
        }
        return temp;
    }}
    ${BoxscoreTeamsGridWrapper} {
        ${({ $type }) => {
        let temp = '';
        if ($type === FULLWIDE) {
            temp = temp + `
                    padding-top: 0px;
                    grid-gap: 0px;
                    padding-bottom: 16px;
                `;
        }
        return temp;
    }}
    }
    ${TeamTable} {
        &.batters{
            thead{
                th{
                    padding-top: 0px;
                    &:first-child{
                        width: 36%;
                    }
                }
            }
        }
        tbody{
            tr{
                &:last-child {
                    th,
                    td{
                        padding-bottom: 0px;
                    }
                }
            }
        }
    }
}`;
